// extracted by mini-css-extract-plugin
export default {"tenderActions":"eDSkm","marker_icon":"SVsI9"};